module.exports = __webpack_public_path__ + "img/1440.cb78de1d.jpg";